export const ValidationEnum = {
    REQUIRED: "REQUIRED",
    REGEXP: "REGEXP",
    LENGTH: "LENGTH",
    MIN: "MIN",
    MAX: "MAX",
    ETC: "ETC",
    RANGE: "RANGE",
};
